import {defineStore} from 'pinia';
import axios from 'axios';
import {MemberProfile} from "@/store/model/MemberProfile";
import {PoliticianProfile} from "@/store/model/PoliticianProfile";
import {authStore} from "@/store/authStore";

export const profileStore = defineStore('profileStore',{
    state: () => ({
        profileGeneralInfo: null,
        memberProfile: null,
        politicianProfile: null
    }),
    getters: {
        politicianIsVerified() {
            return this.politicianProfile !== null && this.memberProfile !== null;
        },
        activeOrgId() {
            return authStore().userActiveProfile.type === "ORGANIZATION"
                ? authStore().userActiveProfile.organizations.filter(org=> org.active)[0].organization.id
                : null;
      }
    },
    actions: {
        getProfileGeneralInfoAction(profileId) {
            return axios.get(`/api/user/profile/${profileId}`);
        },
        getProfileGeneralInfo(profileId) {
            return this.getProfileGeneralInfoAction(profileId).then((res) => {
                this.profileGeneralInfo = res.data;
            });
        },
        getProfileNewsAction(params) {
            return axios.get(`/api/user/profile/news/${params.profileId}`, {
                params: params
            });
        },
        getProfilePoliticianCandidates(profileId) {
            return axios.get(`/api/politician/profiles/${profileId}/candidates`);
        },
        getProfilePoliticianAssignments(profileId) {
            return axios.get(`/api/politician/profiles/${profileId}/assignments`);
        },
        getMemberProfile(memberProfileId) {
            if (!memberProfileId) {
                return Promise.resolve({});
            }
            // TODO: valekseev: 7/15/2025: handle 403 response when requester isn't profile owner and profile has been ever deactivated
            return axios.get(`/api/member/profiles/${memberProfileId}`).then((res) => {
                this.memberProfile = new MemberProfile(res.data);
            });
        },
        getPoliticianProfile(politicianProfileId) {
            return axios.get(`/api/politician/profiles/${politicianProfileId}`).then((res) => {
                this.politicianProfile = new PoliticianProfile(res.data);
            });
        },
        clearProfileInfo() {
            this.memberProfile = null;
            this.politicianProfile = null;
        }
    }
});